import { AxiosPromise } from 'axios';
import { Form } from 'src/models';
import { api } from 'src/services';
import { getAPiVersion } from '.';

/**
 * Get Next Form
 */
export type GetNextFormApiResponse = {
  next_form: Form | null;
  message: string | null;
};

export const getNextFormApi = (): AxiosPromise<GetNextFormApiResponse> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.get('/v3/form/next');
  }

  return api.get('/next_form');
};

/**
 * Add Form Response
 */
export type AddFormResponseApiPayload = {
  form_type: string;
  response: Record<string, unknown> | unknown[];
};

export type AddFormResponseApiResponse = GetNextFormApiResponse;

export const addFormResponseApi = (
  payload: AddFormResponseApiPayload
): AxiosPromise<AddFormResponseApiResponse> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.post('/v3/form_response', payload);
  }

  return api.post('/form_response', payload);
};

/**
 * Web Form - Get Next Form + Prefill Data
 */
export type WebFormNextApiResponse = {
  next_form: Form | null;
  prefill_data: Record<string, unknown>;
};

export const getWebFormNextApi = (): AxiosPromise<WebFormNextApiResponse> => {
  return api.get('/v3/web-form/next');
};

/**
 * Web Form - Submit Form Responses
 */
export type WebFormSubmitPayload = {
  responses: { form_type: string; response: unknown }[];
};

export type WebFormSubmitApiResponse = {
  message: string;
  next_form: Form | null;
  is_complete: boolean;
};

export const submitWebFormApi = (
  payload: WebFormSubmitPayload
): AxiosPromise<WebFormSubmitApiResponse> => {
  return api.post('/v3/web-form/submit', payload);
};

/**
 * Get Medications and Allergies
 */
export type GetMedicationsAndAllergiesApiPayload = {
  chatToken: string;
};

export type GetMedicationsAndAllergiesApiResponse = {
  medications: string[];
  allergies: string[];
};

export const getMedicationsAndAllergiesApi = ({
  chatToken,
}: GetMedicationsAndAllergiesApiPayload): AxiosPromise<GetMedicationsAndAllergiesApiResponse> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.get('/v3/chat/medication_allergy');
  }

  return api.post('/llm/medication_allergies', {
    access_token: chatToken,
  });
};

/**
 * Save Medications and Allergies
 */
export type SaveMedicationsAndAllergiesApiPayload = {
  chatToken: string;
  medications: string;
  allergies: string;
};

export const saveMedicationsAndAllergiesApi = ({
  chatToken,
  medications,
  allergies,
}: SaveMedicationsAndAllergiesApiPayload): AxiosPromise<void> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.put('/v3/chat/medication_allergy', {
      medications,
      allergies,
    });
  }

  return api.post('/review', {
    access_token: chatToken,
    medications,
    allergies,
  });
};
